import { render, staticRenderFns } from "./InstantUpdateSelector.vue?vue&type=template&id=6664936a"
import script from "./InstantUpdateSelector.vue?vue&type=script&lang=ts"
export * from "./InstantUpdateSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports